import React from 'react';
import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <path d="m 21.392077,18.425598 c 0.810564,0.810565 0.810564,2.152282 0,2.963014 -0.419287,0.419287 -0.950439,0.614842 -1.481591,0.614842 -0.530985,0 -1.062137,-0.195555 -1.48144,-0.614842 L 11.999974,14.95949 5.5709191,21.388612 c -0.4192866,0.419287 -0.9503717,0.614842 -1.4814736,0.614842 -0.5310985,0 -1.0621937,-0.195555 -1.4814802,-0.614842 -0.8106203,-0.810732 -0.8106203,-2.152449 0,-2.963014 L 9.0370268,11.996526 2.6079653,5.5674714 c -0.8106203,-0.8106319 -0.8106203,-2.1523388 0,-2.9629589 0.8106201,-0.8106218 2.1523387,-0.8106218 2.9629538,0 l 6.4290549,6.4290503 6.429072,-6.4290503 c 0.810581,-0.8106218 2.152298,-0.8106218 2.963031,0 0.810564,0.8106201 0.810564,2.152327 0,2.9629589 l -6.429139,6.4290546 z" />
  </>,
  'Close',
);
